import { render } from "./footer.vue?vue&type=template&id=71027d38&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=71027d38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71027d38"

export default script